import { t } from 'i18next';

export const translateText = (translateKey: string) => {
  return `${t(translateKey)}`;
};
